import { Injectable } from '@angular/core';
import { addHandler, closeChannelEvent } from '../models/events';

type ValveOrientation = 'horizontal' | 'vertical';

const VALVE_PATH_DATA: Record<'static' | 'closed', Record<ValveOrientation, string>> = {
    static: {
        horizontal:
            'M10.333 13.75a1 1 0 0 0-.6.2L6.6 16.3a1 1 0 0 1-1.6-.8V9a1 1 0 0 1 1.6-.8l3.133 2.35a1 1 0 0 0 .6.2h3.334a1 1 0 0 0 .6-.2L17.4 8.2A1 1 0 0 1 19 9v6.5a1 1 0 0 1-1.6.8l-3.133-2.35a1 1 0 0 0-.6-.2h-3.334z',
        vertical:
            'M10.75 10.333a1 1 0 0 0-.2-.6L8.2 6.6A1 1 0 0 1 9 5h6.5a1 1 0 0 1 .8 1.6l-2.35 3.133a1 1 0 0 0-.2.6v3.334a1 1 0 0 0 .2.6L16.3 17.4a1 1 0 0 1-.8 1.6H9a1 1 0 0 1-.8-1.6l2.35-3.133a1 1 0 0 0 .2-.6v-3.334z',
    },
    closed: {
        horizontal:
            'M14 11.25a1 1 0 0 1 .4-.8l3-2.25A1 1 0 0 1 19 9v6.5a1 1 0 0 1-1.6.8l-3-2.25a1 1 0 0 1-.4-.8v-2zM10 11.25a1 1 0 0 0-.4-.8l-3-2.25A1 1 0 0 0 5 9v6.5a1 1 0 0 0 1.6.8l3-2.25a1 1 0 0 0 .4-.8v-2z',
        vertical:
            'M11.25 10a1 1 0 0 1-.8-.4l-2.25-3A1 1 0 0 1 9 5h6.5a1 1 0 0 1 .8 1.6l-2.25 3a1 1 0 0 1-.8.4h-2zM11.25 14a1 1 0 0 0-.8.4l-2.25 3A1 1 0 0 0 9 19h6.5a1 1 0 0 0 .8-1.6l-2.25-3a1 1 0 0 0-.8-.4h-2z',
    },
};

@Injectable({ providedIn: 'root' })
export class ValveService {
    addDefaultValveListener(elem: Element, elementSetting: any) {
        const valvePath = elem.querySelector('path.valve-body') as SVGPathElement;
        if (!valvePath) return;

        const orientation: ValveOrientation =
            elementSetting.valveSetting?.orientation === 'vertical' ? 'vertical' : 'horizontal';
        const staticD = VALVE_PATH_DATA.static[orientation];
        const closedD = VALVE_PATH_DATA.closed[orientation];
        const closeChannelTag = elementSetting.valveSetting?.close?.channelTag;

        if (!closeChannelTag) return;

        const handler = async (event: CustomEvent) => {
            const { value } = event.detail;
            valvePath.setAttribute('d', value === 1 ? closedD : staticD);
        };
        addHandler(elem, closeChannelEvent, handler);
    }
}
